import React from 'react'

import { Container, Section } from './styled'
import { Button } from '../../components/common/Button'
import { useNavigate } from 'react-router-dom'

import { Helmet } from 'react-helmet'

export const PageNotFound = () => {
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>Página não encontrada</title>
        <meta name="Página não encontrada" content="Página não encontrada" />
      </Helmet>
      <Container>
        <Section>
          <h1>:(</h1>
        </Section>
        <Section>
          <h2>404 - PÁGINA NÃO ENCONTRADA</h2>
          <p>A página que você está procurando foi removida ou não existe. </p>
          <div>
            <Button.Root
              backgroundColor="#150D49"
              type="button"
              padding="1rem"
              onClick={() => {
                navigate('/')
              }}
            >
              <Button.Content
                title="Home Page"
                color="#f2f2f2"
                fontSize="16px"
              />
            </Button.Root>
          </div>
        </Section>
      </Container>
    </>
  )
}
